import { useAuth } from '../auth/useAuth';

/**
 * Sollen die Einstiege zu „Mitglied werden" angezeigt werden?
 *
 * Die Regel steht hier an EINER Stelle, weil sie an sechs hängt: Header,
 * Footer, Hero, die beiden Terminlisten und das Gate an der Route selbst.
 *
 * Entscheidend ist `user`, NICHT `isActiveMember`: Wer angemeldet, aber noch
 * nicht freigegeben ist, hat sich bereits registriert - ihm ein zweites Mal
 * „Jetzt registrieren" anzubieten wäre gerade in dieser Wartezeit verwirrend.
 *
 * Während `loading` gilt bewusst „anzeigen": Für nicht angemeldete Besucher -
 * also die allermeisten auf den öffentlichen Seiten - ist das der richtige
 * Zustand, und sie sind das eigentliche Ziel dieser Aufrufe. Ein angemeldetes
 * Mitglied sieht die Einstiege dadurch einen Wimpernschlag lang, bevor sie
 * verschwinden; umgekehrt wäre der Aufruf für jeden Gast kurz weg.
 */
export function useJoinVisible() {
  const { user, loading } = useAuth();
  return loading || !user;
}
